import { render } from "./DanhSachChuyenDi.vue?vue&type=template&id=6c0d5ead&scoped=true"
import script from "./DanhSachChuyenDi.vue?vue&type=script&lang=js"
export * from "./DanhSachChuyenDi.vue?vue&type=script&lang=js"

import "./DanhSachChuyenDi.vue?vue&type=style&index=0&id=6c0d5ead&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0d5ead"]])

export default __exports__